/* unplugin-vue-components disabled */import { render } from "./weaviate.vue?vue&type=template&id=05ad9507&scoped=true"
import script from "./weaviate.vue?vue&type=script&setup=true&lang=js"
export * from "./weaviate.vue?vue&type=script&setup=true&lang=js"

import "./weaviate.vue?vue&type=style&index=0&id=05ad9507&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05ad9507"],['__file',"src/pages/settings/admin/weaviate/weaviate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05ad9507"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05ad9507', __exports__)) {
    api.reload('05ad9507', __exports__)
  }
  
  module.hot.accept("./weaviate.vue?vue&type=template&id=05ad9507&scoped=true", () => {
    api.rerender('05ad9507', render)
  })

}


export default __exports__